import React from 'react';

export const FileArchiveContext = React.createContext({});
